<template>
  <div class="spinner-container">
    <div>
      <span class="spinner-grow" role="status" aria-hidden="true"></span>
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30vh;
  color: $apnic-blue;
}
</style>
